import { styled } from '@mui/material';
import MuiToggleButtonGroup, {
    ToggleButtonGroupProps,
} from '@mui/material/ToggleButtonGroup';
import React from 'react';

const StyToggleButtonGroup = styled(MuiToggleButtonGroup, {
    name: 'StyToggleButtonGroup',
})({
    '& .MuiToggleButtonGroup-grouped': {
        border: 'none',
        '&:not(:last-child)': {
            marginRight: '1rem',
        },
    },
    '& .MuiToggleButtonGroup-grouped.Mui-disabled': {
        border: 'none',
    },
});

const ToggleButtonGroup = (
    props: ToggleButtonGroupProps,
): React.ReactElement => <StyToggleButtonGroup {...props} />;

export default ToggleButtonGroup;
